import { useNavigate } from "react-router-dom";

//Mui
import { Stack } from "@mui/material";

// Local
import AuthCard from "../../components/UI/Cards/AuthCard";
import FormFieldsContainer from "../../components/Layout/FormFieldsContainer";
import PrimaryTextField from "../../components/UI/Form/PrimaryTextField";
import PrimaryButton from "../../components/UI/Buttons/PrimaryButton";
import SecondaryButton from "../../components/UI/Buttons/SecondaryButton";
import PasswordInput from "../../components/UI/Form/PasswordInput";
import useApiHttp from "../../hooks/use-http";
import {
  validateEmail,
  validatePassword,
  validatePhoneNumber,
  validateTextInput,
} from "../../util/validation";
import useInput from "../../hooks/use-input";
import { Button, Container, InputField } from "@jds/core";
import { useState } from "react";

export default function Signup(props) {
  const navigate = useNavigate();

  const [passwordView, setPasswordView] = useState({
    password: {
      type: "password",
      suffix: "IcVisible",
    },
    newPassword: {
      type: "password",
      suffix: "IcVisible",
    },
  });

  const {
    value: name,
    isValid: isValidName,
    hasError: nameError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
    reset: resetName,
  } = useInput(validateTextInput);

  const {
    value: email,
    isValid: isValidEmail,
    hasError: emailError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmail,
  } = useInput(validateEmail);

  const {
    value: phno,
    isValid: isValidPhno,
    hasError: phNoError,
    valueChangeHandler: phNoChangeHandler,
    inputBlurHandler: phNoBlurHandler,
    reset: resetPhno,
  } = useInput(validatePhoneNumber);
  const {
    value: password,
    isValid: isValidPassword,
    hasError: passwordError,
    valueChangeHandler: passwordChangeHandler,
    inputBlurHandler: passwordBlurHandler,
    reset: resetPassword,
  } = useInput(validatePassword);

  const {
    value: newPassword,
    isValid: isValidNewPassword,
    hasError: newPasswordError,
    valueChangeHandler: newPasswordChangeHandler,
    inputBlurHandler: newPasswordBlurHandler,
    reset: resetNewpassword,
  } = useInput(validatePassword);

  const { sendRequest: signUpUser } = useApiHttp();
  const isValidForm =
    !isValidName ||
    !isValidEmail ||
    !isValidPhno ||
    !isValidPassword ||
    !isValidNewPassword ||
    newPassword !== password;
  const loginClickHandler = () => {
    navigate("/auth/signin");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    signUpUser(
      {
        url: `event-types/get-all`,
        method: "GET",
      }
      // culumData
    );
  };

  const handlePasswordView = (name) => {
    setPasswordView((prev) => {
      return {
        ...prev,
        [name]: {
          type: prev[name]["type"] === "password" ? "text" : "password",
          suffix:
            prev[name]["suffix"] === "IcVisible" ? "IcVisibleOff" : "IcVisible",
        },
      };
    });
  };
  return (
    <AuthCard title="up">
      <form onSubmit={handleSubmit}>
        <Container
          style={{ width: "100%", margin: "48px 0" }}
          direction="column"
          gap={24}
        >
          <InputField
            type="text"
            value={name}
            stateText="name is invalid"
            onChange={nameChangeHandler}
            onBlur={nameBlurHandler}
            state={nameError ? "error" : ""}
            label="Name"
            name="name"
          />
          <InputField
            type="text"
            value={email}
            stateText={"invalid email"}
            onChange={emailChangeHandler}
            onBlur={emailBlurHandler}
            label="Email Address"
            name="email"
            state={emailError ? "error" : ""}
          />
          <InputField
            type="number"
            label="+91 Phone Number"
            name="phno"
            value={phno}
            onChange={phNoChangeHandler}
            onBlur={phNoBlurHandler}
            stateText="invalid phone number"
            state={phNoError ? "error" : ""}
          />
          <InputField
            value={password}
            type={passwordView.password.type}
            label="Password"
            name="password"
            onChange={passwordChangeHandler}
            onBlur={passwordBlurHandler}
            stateText="invalid password"
            state={passwordError ? "error" : ""}
            suffix={passwordView.password.suffix}
            onSuffixClick={(e) => {
              handlePasswordView("password");
            }}
          />
          <InputField
            value={newPassword}
            type={passwordView.newPassword.type}
            label="Confirm Password"
            name="newPassword"
            onChange={newPasswordChangeHandler}
            onBlur={newPasswordBlurHandler}
            stateText="invalid password"
            state={
              newPasswordError ||
              (isValidNewPassword && newPassword !== password)
                ? "error"
                : ""
            }
            suffix={passwordView.newPassword.suffix}
            onSuffixClick={(e) => {
              handlePasswordView("newPassword");
            }}
          />
        </Container>

        <Container fullWidth direction="row" gap={"10px"}>
          <Button
            type="submit"
            fullWidth
            disabled={isValidForm}
            kind="secondary"
            size="large"
            label="Button"
          >
            Sign Up
          </Button>
          <Button
            onClick={loginClickHandler}
            fullWidth
            kind="primary"
            size="large"
            label="Button"
          >
            Log in
          </Button>
        </Container>
      </form>
    </AuthCard>
  );
}
